import { SortByType } from '../types/SortByType';

type DateToShow = 'createdAt' | 'updatedAt';

export const DateToShowMap = {
  fromSortBy: (sortBy: SortByType): DateToShow => {
    switch (sortBy) {
      case SortByType.CREATED_AT_ASCEND:
      case SortByType.CREATED_AT_DESCEND:
        return 'createdAt';
      case SortByType.UPDATED_AT_ASCEND:
      case SortByType.UPDATED_AT_DESCEND:
        return 'updatedAt';
      default:
        return 'updatedAt';
    }
  },
};
